export default __webpack_public_path__ + "static/media/envoyer-un-mail.4239e1b7.png";